import OptionFilter from './option-filter';

class ContactForm {
  /**
   * Initializes various frontend features with the given form.
   * @param {Object} options -
   * @param {HTMLFormElement} options.form - The form element to attach to
   */
  constructor({ form }) {
    if(!(form instanceof HTMLFormElement)) return;
    this.form = form;

    this.initFilteredSelects(
      this.form.querySelectorAll('select[data-filter-id]')
    );

    this.contactTypeSelect = this.form.querySelector('#contact_type');
    this.makeSelect = this.form.querySelector('#make');
    if(this.contactTypeSelect && this.makeSelect) {
      this.vehicleSelectsContainer = this.makeSelect.closest('fieldset');
      this.vehicleSelects = this.vehicleSelectsContainer.querySelectorAll('select');
      this.contactTypeSelect.addEventListener('change', () => this.contactTypeChange());
      this.contactTypeChange();
    }
  }

  /**
   * Instantiates a new OptionFilter for eligible selects
   * The select elements should have a data-filter-id attribute,
   * where the value equals the ID of the select that triggers the filter.
   * @param {HTMLCollection|HTMLElement[]} filteredSelects - List of filterable selects
   */
  initFilteredSelects(filteredSelects) {
    filteredSelects.forEach(targetSelect => {
      const filterSelect = document.getElementById(targetSelect.dataset.filterId);
      if(!filterSelect) return;
      new OptionFilter({ filterSelect, targetSelect });
    });
  }

  /**
   * Updates vehicle selects visibility state,
   * based on the current contact type selection.
   */
  contactTypeChange() {
    const { value } = this.contactTypeSelect;
    const showVehicleSelects = (
      ['offer', 'funding', 'test_drive'].includes(value) &&
      value !== 'contact'
    );
    this.displayVehicleSelects(showVehicleSelects);
    this.dummyFields(['make', 'model'], showVehicleSelects);
  }

  /**
   * Hack to make required stage form select fields non-required
   * It creates hidden inputs for given field names, and uses
   * a samples value from the actual select, to bypass Stage's
   * form validation.
   * @param {String[]} fieldNames - List of form fields to derequire
   * @param {Boolean} remove - Resets dummy fields only, if set to true
   */
  dummyFields(fieldNames, remove) {
    document.querySelectorAll(fieldNames.map(
      fieldName => `input[type="hidden"][name=${fieldName}]`).join(',')
    ).forEach(input => {
      input.parentElement.removeChild(input);
    });
    if(!remove) {
      fieldNames.forEach(fieldName => {
        const input = document.createElement('input');
        input.name = fieldName;
        input.type = 'hidden';
        const select = this.form.querySelector(`select[name=${fieldName}]`);
        try {
          const selectValue = ([...select.options].find(opt => opt.value) || {}).value;
          input.value = selectValue || 'none';
        } catch(e) {
          input.value = 'none';
        }
        this.form.appendChild(input);
        console.log(select, fieldName, input.value);
      });
    }
  }

  /**
   * Toggles visibility of vehicle dropdowns section
   * @param {Boolean} visible - Disables and hides the selects, if falsey
   */
  displayVehicleSelects(visible = true) {
    this.vehicleSelectsContainer.classList.toggle('d-none', !visible);
    this.vehicleSelects.forEach(select => {
      select.disabled = !visible;
      if(visible) return;
      // reset current selection
      select.selectedIndex = -1;
      select.value = '';
      // coerce multiselect to refresh it's view
      const changeEvent = new Event('change');
      select.dispatchEvent(changeEvent);
    });
  }
}

export { ContactForm };
export default {
  init: () => {
    document.querySelectorAll('.stage-form')
      .forEach(form => new ContactForm({ form }));
  }
};
